

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"6","height":"16","viewBox":"0 0 6 16"}, rest), ["\n  ", h('g', {"fill":"#23232A","fill-rule":"evenodd","opacity":".5"}, ["\n    ", h('polygon', {"points":"3 0 6 6 0 6"}, []), "\n    ", h('polygon', {"points":"3 9.75 6 15.75 0 15.75","transform":"matrix(1 0 0 -1 0 25.5)"}, []), "\n  "]), "\n"]);
};

        